import {
  Box,
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  TextField,
} from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import ManagementSearchBar from '../shared/ManagementSearchBar'
import NegativeSalesShopFilter from './NegativeSalesShopFilter'
import { SEARCH_DEBOUNCE_MS } from './constants'

export default function NegativeSalesReportFilters({
  selectedOrgs,
  onOrgsChange,
  from,
  to,
  onFromChange,
  onToChange,
  fromError,
  toError,
  search,
  onSearchApply,
  onRefresh,
  loading,
  exporting,
  exportDisabled,
  exportAnchor,
  onExportOpen,
  onExportClose,
  onExport,
  onViewExports,
}) {
  return (
    <Box sx={{ mb: 2 }}>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          mb: 2,
          flexWrap: 'wrap',
          alignItems: 'flex-start',
        }}
      >
        <NegativeSalesShopFilter
          selectedOrgs={selectedOrgs}
          onChange={onOrgsChange}
        />
        <TextField
          label="From"
          type="date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={from}
          onChange={(e) => onFromChange(e.target.value)}
          error={Boolean(fromError)}
          helperText={fromError || ' '}
        />
        <TextField
          label="To"
          type="date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={to}
          onChange={(e) => onToChange(e.target.value)}
          error={Boolean(toError)}
          helperText={toError || ' '}
        />
        <Button
          variant="contained"
          onClick={onRefresh}
          disabled={loading}
          sx={{ mt: 0.5 }}
        >
          Refresh
        </Button>
        <Button
          variant="outlined"
          onClick={onViewExports}
          sx={{ mt: 0.5 }}
        >
          Exports
        </Button>
        <Button
          variant="outlined"
          startIcon={
            exporting ? <CircularProgress size={16} /> : <DownloadIcon />
          }
          onClick={onExportOpen}
          disabled={exportDisabled}
          sx={{ mt: 0.5 }}
        >
          Export
        </Button>
        <Menu
          anchorEl={exportAnchor}
          open={Boolean(exportAnchor)}
          onClose={onExportClose}
        >
          <MenuItem onClick={() => onExport('csv')} disabled={exporting}>
            CSV
          </MenuItem>
          <MenuItem onClick={() => onExport('xlsx')} disabled={exporting}>
            Excel (.xlsx)
          </MenuItem>
        </Menu>
      </Box>
      <ManagementSearchBar
        label="Search"
        placeholder="Search by Article Code or Product Name"
        debounceMs={SEARCH_DEBOUNCE_MS}
        appliedSearch={search}
        onApplySearchQuery={onSearchApply}
        maxWidth={480}
        mb={0}
      />
    </Box>
  )
}
